if (!customElements.get("sizeguide-modal")) {
  class SizeguideModal extends HTMLElement {
    static OPEN_CLASS = "is-open";
    static ACTIVE_CLASS = "is-active";

    constructor() {
      super();

      this.handleToggleRef = this.handleToggle.bind(this);
    }

    handleToggle() {
      this.classList.toggle(SizeguideModal.OPEN_CLASS);
    }

    handleClick(event) {
      const anchor = event.target.closest("a");
      if (!anchor.hasAttribute("js-index")) return;

      const targetTab = this.tabs[Number(anchor.getAttribute("js-index"))];
      if (!targetTab) return;

      event.preventDefault();

      this.querySelectorAll(`.${SizeguideModal.ACTIVE_CLASS}`).forEach(
        (element) => element.classList.remove(SizeguideModal.ACTIVE_CLASS)
      );

      anchor.classList.add(SizeguideModal.ACTIVE_CLASS);
      targetTab.classList.add(SizeguideModal.ACTIVE_CLASS);
    }

    handleResize() {
      if (!this.offsetElement) return;

      this.style.setProperty(
        "--offset",
        this.offsetElement.clientHeight + "px"
      );
    }

    disconnectedCallback() {
      document.removeEventListener("sizeguide:toggle", this.handleToggleRef);
    }

    connectedCallback() {
      if (this.parentNode !== document.body) {
        document.body.appendChild(this);
      }

      if (this.tabs) return;

      document.addEventListener("sizeguide:toggle", this.handleToggleRef);

      this.tabs = this.querySelectorAll("[js-tab]");
      this.addEventListener("click", this.handleClick.bind(this));

      this.offsetElement = this.querySelector("[js-offset]");
      if (!this.offsetElement) return;

      window.addEventListener("resize", this.handleResize.bind(this));
      this.handleResize();
    }
  }

  customElements.define("sizeguide-modal", SizeguideModal);
}
